import { useEffect } from 'react';
import L from 'leaflet';
import { damagePoints } from '../lib/maint';

export default function useHeatLayer(mapRef, on, fittings, pipes, pits, faults) {
  useEffect(() => {
    const map = mapRef.current;
    if (!on || !map) return undefined;
    let layer = null, alive = true;
    window.L = L;
    import('leaflet.heat').then(() => {
      if (!alive) return;
      layer = L.heatLayer([...damagePoints(fittings, pipes, pits), ...(faults || []).flatMap((f) => f.pins.map((p) => [p[0], p[1], 1.2]))], {
        radius: 38, blur: 26, maxZoom: 17, max: 2, minOpacity: 0.35,
        gradient: { 0.2: '#fde047', 0.5: '#f97316', 0.8: '#dc2626', 1: '#7f1d1d' },
      }).addTo(map);
      layer._canvas?.setAttribute('data-testid', 'heatmap-canvas');
    });
    return () => { alive = false; layer && map.removeLayer(layer); };
  }, [mapRef, on, fittings, pipes, pits, faults]);
}
